export default __webpack_public_path__ + "img/7aaeab9a5521ca7483080346003fb867.png";